const PAGE_DIRECTORY = "travel-insurance-articles";

import { getArticlePaths, getArticleData } from "@lib/strapiFunctions/articles";
import LiveWellArticles from "@components/Articles/LivewellArticles";
import { useEffect } from "react";
import Script from "next/script";

function Article({
  homePageData,
  isds,
  pageData,
  subNavBarLinks,
  slug,
  domain,
  preview,
  leadFormEnabled,
  leadFormData
}) {
  useEffect(() => {
    window.lmSMTObj &&
      window.lmSMTObj.page(
        "travel-insurance-articles",
        {
          path: "/",
          referrer: document.referrer,
          title: document.title,
          url: location.href,
          search: location.search,
        },
        []
      );
  }, []);
  return (
    <>
      <Script id="google-tag-manager" type="text/javascript" defer>
        {`window.lmSMTObj = window.lmSMTObj || [];
    var methods = [
        "init",
        "page",
        "track",
        "identify"
    ]
    for (var i=0; i<methods.length; i++) {
        lmSMTObj[methods[i]] = function(methodName){
            if(methodName !== "init") {
              return function() {
                  lmSMTObj.push([methodName].concat(Array.prototype.slice.call(arguments)));
                  var fn = arguments[arguments.length-1];
                  setTimeout(function() {
                    if(typeof fn === "function" && !lmSMTObj.smartTagversion) {
                      fn();
                      lmSMTObj.length > 0 ? lmSMTObj[lmSMTObj.length-1].push("callbackEnded"): null;
                    }
                  }, 2000);
    
                }
            }
            return function(){
                lmSMTObj.push([methodName].concat(Array.prototype.slice.call(arguments)));
            };
        }(methods[i]);
    }
    lmSMTObj.init("dpxml3k6cmk5bll6p0wn");
    var a = document.createElement("script");
    a.type = "text/javascript";
    a.async = !0;
    a.src = "//cdn25.lemnisk.co/ssp/st/6323.js";
    var b = document.getElementsByTagName("script")[0];
    b.parentNode.insertBefore(a, b);`}
      </Script>
    <LiveWellArticles
      homePageData={homePageData}
      isds={isds}
      pageData={pageData}
      subNavBarLinks={subNavBarLinks}
      slug={slug}
      domain={domain}
      pageDirectory={PAGE_DIRECTORY}
      preview={preview}
      leadFormEnabled={leadFormEnabled}
      leadFormData={leadFormData}
      pageType="Travel-Insurance-Articles"
    />
     </>
  );
}

export default Article;

export async function getStaticPaths() {
  return await getArticlePaths(PAGE_DIRECTORY);
}

export async function getStaticProps(context: any) {
  return await getArticleData(context, PAGE_DIRECTORY);
}
